const JOB_NAME = /^[a-z][a-z0-9]*(\.[a-z][a-z0-9-]*)+$/;
/** A job contract; throws when a name is malformed or the example fails the payload. */
export function defineJob(definition) {
    for (const name of [definition.id, definition.queue]) {
        if (!JOB_NAME.test(name))
            throw new TypeError(`job name "${name}" must be dotted lower case`);
    }
    const parsed = definition.payload.safeParse(definition.example);
    if (!parsed.success) {
        throw new TypeError(`job ${definition.id}: the example does not match its payload`);
    }
    return Object.freeze({ ...definition, retryLimit: 0 });
}
//# sourceMappingURL=define-job.js.map